import { filterL, go, map } from "fxjs/es";
import { PathEditorNS } from "../../../../../../PathEditor/PathEditorNS.js";
export const getClosePathCommandList = (self) => {
  return go(
    self._path_editor_list,
    filterL(({ model }) => model instanceof PathEditorNS.ModelNS.CommandZ),
    map(({ model }) => model)
  );
};
